"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIsStoreBusyValid = void 0;
exports.parseInstantGglocations = parseInstantGglocations;
exports.parseTimeSlotGglocations = parseTimeSlotGglocations;
var _moment = _interopRequireDefault(require("moment"));
var _lodash = require("lodash");
var _utils = require("@spq/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function parseGglocation(gglocation) {
  const {
    deliveryProcessingTime,
    scheduledDeliveryCutoffTime,
    processingTime,
    cutoffTime
  } = gglocation;
  const otherValues = (0, _lodash.pickBy)(gglocation, (value, key) => !["deliveryProcessingTime", "scheduledDeliveryCutoffTime", "processingTime", "cutoffTime", "scheduledDeliveryOrderTime", "scheduledOrderTime", "scheduledDeliveryOrderCutoffTime", "scheduledOrderCutoffTime"].includes(key));
  return {
    processingTime: {
      default: processingTime,
      delivery: deliveryProcessingTime
    },
    cutoffTime: {
      default: cutoffTime,
      delivery: scheduledDeliveryCutoffTime
    },
    ...otherValues
  };
}
const parseScheduledOrderTimes = scheduledOrderTimes => (0, _lodash.chain)(scheduledOrderTimes).flatMap().groupBy(scheduleOrderTime => (0, _moment.default)(scheduleOrderTime).format("YYYY-MM-DD")).value();
function parseInstantGglocations(gglocations) {
  const result = {
    gglocations: {}
  };
  gglocations.forEach(gglocation => {
    const {
      gglocationType,
      gglocationId,
      scheduledDeliveryOrderTime,
      scheduledOrderTime
    } = gglocation;
    const id = "".concat(gglocationType, "_").concat(gglocationId);
    const scheduledOrderTimes = (0, _lodash.mapValues)({
      default: scheduledOrderTime,
      delivery: scheduledDeliveryOrderTime
    }, parseScheduledOrderTimes);
    result.gglocations[id] = {
      ...parseGglocation(gglocation),
      id,
      type: "instant",
      openingHours: gglocation.openingHours.sort(_utils.compareDates),
      scheduledOrderTimes
    };
  });
  return result;
}
function parseTimeSlotGglocations(gglocations) {
  const result = {
    timeSlots: {},
    gglocations: {}
  };
  gglocations.map(gglocation => {
    const timeSlotIds = gglocation.timeSlots.sort((timeSlotA, timeSlotB) => (0, _utils.compareDates)(timeSlotA.datetime, timeSlotB.datetime)).map(timeSlot => {
      const timeSlotId = timeSlot.id.toString();
      result.timeSlots[timeSlotId] = {
        ...timeSlot,
        id: timeSlotId
      };
      return timeSlotId;
    });
    const id = "".concat(gglocation.gglocationType, "_").concat(gglocation.gglocationId);
    result.gglocations[id] = {
      ...parseGglocation(gglocation),
      id,
      type: "scheduled",
      timeSlots: timeSlotIds
    };
    return gglocation;
  });
  return result;
}
const checkIsStoreBusyValid = _ref => {
  let {
    startTime,
    endTime,
    isManuallyCancelled
  } = _ref;
  return (0, _moment.default)().isBetween(startTime, endTime) && !isManuallyCancelled;
};
exports.checkIsStoreBusyValid = checkIsStoreBusyValid;